
import { createApp } from 'vue';
import App from './App.vue';
import router from './router/route';
import store from './store/index';

// Import Styles
import './assets/tailwind.css'; // Tailwind CSS

// Import Element Plus UI Library
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import locale from 'element-plus/es/locale/lang/en'; // English locale

// Import Highcharts
import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';

// Create the Vue App Instance
const app = createApp(App);

// Use Plugins & Store
app.use(router);
app.use(store);
app.use(ElementPlus, { locale });
app.use(HighchartsVue, { Highcharts });


// Mount the Vue App
app.mount('#app');
